import React from 'react';
import styles from './PaymentSuccess.module.css';

const PaymentSuccess: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Payment Successful!</h1>
      <p className={styles.message}>Thank you for your payment. Your invoice has been marked as paid.</p>
      <p className={styles.redirect}>You will be redirected to the dashboard shortly...</p>
      {/* Optional: Add a button to manually go to dashboard */}
      {/* <a href="/dashboard" className={styles.dashboardLink}>Go to Dashboard</a> */}
    </div>
  );
};

export default PaymentSuccess;
